import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { HelpInfosParams, ServiceTypesGroupingModeValues } from 'types';

import {
  fetchHelpInfos,
  fetchedHelpInfos,
  fetchedHelpInfosMessageAssisant,
  fetchHelpInfosMessageAssisant,
} from './actions';
import getAPI from '../../api/iv-back';
import { logout } from '../api-auth/actions';
import { sagaWithCallback } from '../utils';

type FetchActionPayload = ReturnType<typeof fetchHelpInfos>;

export function* getHelpInfosSaga({ meta, payload }: FetchActionPayload) {
  const { getHelpInfos } = getAPI();
  const { isMessageAssistant } = meta;

  let helpInfo: HelpInfosParams | undefined;
  if (payload) {
    const { selectedServiceTypes, serviceTypesGroupingMode, ...rest } = payload;
    helpInfo = rest;
    if (selectedServiceTypes?.length) {
      if (!isMessageAssistant) {
        helpInfo.isExactFilterServiceType = serviceTypesGroupingMode === ServiceTypesGroupingModeValues.ET;
      }
      helpInfo.serviceTypeIDs = selectedServiceTypes;
    }
  }

  const response: YieldOf<typeof getHelpInfos> = yield call(getHelpInfos, helpInfo);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    if (isMessageAssistant) {
      yield put(fetchedHelpInfosMessageAssisant(data));
    } else {
      yield put(fetchedHelpInfos(data));
    }
    return data;
  } else {
    const error = problem || 'unknown';
    yield put(fetchedHelpInfos(undefined, error));
    throw new Error('get help infos failed: ' + error);
  }
}

export default function* helpInfosSaga() {
  yield takeLatest(fetchHelpInfos.type, getHelpInfosSaga);
  yield takeLatest(fetchHelpInfosMessageAssisant.type, sagaWithCallback(getHelpInfosSaga));
}
